<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer009">
<p class="pl-fl-roman">Dear Reader,</p>
<p class="pl-fl-roman">I’ll admit it: I like to get presents. I give good ones, too. Part of the fun of Christmas in our house—and yours, too, I imagine—is unwrapping presents from friends and family. I’ve long since given up the more childlike anticipation that involves shaking a package and hoping for a clue about what is inside, but I still anticipate.</p>
<p class="pl-fl-roman">Quite often in our family we give each other books. The fun lies in discovering what someone we know and love thinks we might like to read. How well do they know us?</p>
<p class="pl-fl-roman">This is the story about a wartime journal and a Royal Navy captain returning it to a family in mourning after the history-changing Battle of Trafalgar. Captain Everard has no other plan beyond returning a young lieutenant’s personal property. He’s done it before, and as the long war grinds on, he’ll likely do it again.</p>
<p class="pl-fl-roman">Through the special magic of Christmas, this prosaic duty, not uncommon during wartime, assumes much greater significance. Two people who are expecting nothing beyond the ordinary this sad Christmas find themselves swept up into something extraordinary.</p>
<p class="pl-fl-roman">Or so we assume. Everyone assumes in this story, for good or ill. And since this is a Christmas story, let us assume it’s for good.</p>
<p class="pl-fl-roman">Sincerely,</p>
<p class="pl-fl-roman"><em class="italic">Carla Kelly</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dear_Reader.vue?09db31ac